import {IBookmark} from '@/common/types/IBookmark';
import {extractDomain} from '@/common/utilities/display/text';
import {APP_CONSTANTS} from "@/utilities/constants/AppConstants.ts";

interface MetadataResponse {
  title?: string;
  description?: string;
  image?: string;
  source?: string;
  tags?: Array<{ name: string }>;
  categories?: string[];
}

export class WebMetadataService {
  private static readonly API_BASE_URL = APP_CONSTANTS.API_BASE_URL;

  static async extractMetadata(url: string): Promise<Partial<IBookmark>> {
    try {
      // Use backend API for metadata extraction (handles CORS)
      const response = await fetch(`${this.API_BASE_URL}/metadata/data`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({url}),
      });

      if (!response.ok) {
        throw new Error(`API request failed: ${response.statusText}`);
      }

      const apiMetadata: MetadataResponse = await response.json();

      return {
        url,
        title: apiMetadata.title,
        description: apiMetadata.description,
        image: apiMetadata.image,
        source: apiMetadata.source || extractDomain(url),
        type: 'url',
        addedOn: Date.now(),
        tags: apiMetadata.tags,
        categories: apiMetadata.categories,
        is_starred: 'false',
        viewCount: 0,
        clickCount: 0,
      };
    } catch (error) {
      console.error('Error extracting metadata:', error);
      // Return basic bookmark if API fails
      return {
        url,
        type: 'url',
        title: url,
        source: extractDomain(url),
        addedOn: Date.now(),
        is_starred: 'false',
        viewCount: 0,
        clickCount: 0,
      };
    }
  }
}
